import { apiService } from './api';

export interface ServiceItemDTO {
  id: number;
  code: string;
  name: string;
  defaultDescription?: string | null;
  defaultPrice: number;
  allowPriceChange: boolean;
  allowDescriptionChange: boolean;
  taxRate: number;
  isActive: boolean;
  sortOrder: number;
}

export interface CreateServiceItemRequest {
  code: string;
  name: string;
  defaultDescription?: string;
  defaultPrice: number;
  allowPriceChange: boolean;
  allowDescriptionChange: boolean;
  taxRate: number;
  isActive: boolean;
  sortOrder: number;
}

export type UpdateServiceItemRequest = CreateServiceItemRequest;

const BASE = '/service-items';

export const serviceItemService = {
  getAll: () => apiService.get<ServiceItemDTO[]>(BASE),

  getById: (id: number) => apiService.get<ServiceItemDTO>(`${BASE}/${id}`),

  create: (data: CreateServiceItemRequest) =>
    apiService.post<ServiceItemDTO>(BASE, data),

  update: (id: number, data: UpdateServiceItemRequest) =>
    apiService.put<ServiceItemDTO>(`${BASE}/${id}`, data),

  delete: (id: number) => apiService.delete<void>(`${BASE}/${id}`),
};
